export const EXIT_TRANSITION_DURATION = 250
